import React from "react";
import { Link } from "react-router-dom";

const PostTag = props => {
  const tag_title = props.tag_title;
  const tags = props.tags;

  return (
    <div className="my-8">
      <span>{tag_title}</span>
      {tags.map((tag, i) => {
        var link_url = `${tag.type}`;

        if (tag_title === "Bills") link_url = `/data/bills/${tag.id}`;
        else if (tag_title === "Topics") link_url = `/data/topics/${tag.id}`;
        else if (tag_title === "Subtopics") link_url = `/data/issues/${tag.id}`;
        else if (tag_title === "Contacts") link_url = `/people/${tag.id}`;

        return (
          <div key={tag.id} className="my-1">
            <Link
              to={link_url}
              key={i}
              className="no-underline items-center justify-center px-3 py-1 mr-1 text-xs font-bold leading-none text-white bg-blue-400 rounded-full"
            >
              {tag_title === "Bills" ? tag.name.split(":")[0] : tag.name}
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default PostTag;
